import { writable } from "svelte/store";
import { browser } from "$app/environment";

const stored = browser ? localStorage.getItem("practical-lang") : null;
const initial = stored || "de";

export const lang = writable<string>(initial);

function applyLang(val: string) {
  if (!browser) return;
  document.body.className = val === "en" ? "en" : "";
}

// Apply on first load
applyLang(initial);

lang.subscribe((val) => {
  if (browser) {
    localStorage.setItem("practical-lang", val);
  }
  applyLang(val);
});
